import { render, staticRenderFns } from "./writeSqlModal.vue?vue&type=template&id=152c8418&scoped=true&"
import script from "./writeSqlModal.vue?vue&type=script&lang=js&"
export * from "./writeSqlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c8418",
  null
  
)

export default component.exports